import React from 'react';

import H7WingcoreProduct from '../../../main/assets/images/wingcore/h7-wingcore-product.webp';

export const Hero = () => {
  return (
    <section className="wingcore-hero-parent">
      <div className="wingcore-hero-bg" />
      <div className="wingcore-hero">
        <div className="wingcore-hero-text">
          <div className="wingcore-hero-title-section">
            <h1 className="wingcore-hero-subtitle">FLIGHT CONTROLLER</h1>
            <h2 className="wingcore-hero-title">H7 WINGCORE</h2>
          </div>
          <p className="wingcore-hero-description">
            The H7 WingCore is a fully NDAA-compliant dual-use flight controller
            for fixed-wing and VTOL drones.
          </p>
          <div className="dreamX__discover--button">
            <a
              href="https://shop.orqafpv.com/products/orqa-h7-wingcore"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn--primary btn--med"
              onMouseDown={event => event.preventDefault()}
            >
              buy now
            </a>
          </div>
        </div>
        <img
          src={H7WingcoreProduct}
          alt="Wingcore H7 product"
          className="wingcore-hero-product"
        />
      </div>
    </section>
  );
};
